
import { setCountdown } from '../../libs/utils/setCountdown'
import { loadSectionTranslations } from '../../i18n-setup'

export default {
  name: 'sgh-header-top-controller',
  data() {
    return {
      active: false,
    }
  },
  mounted() {
    this.$root.$on('activeController', () => {
      this.active = true
      if (this.isMobile) document.body.style.overflow = 'hidden'
      this.$nextTick(function() {
        this.setCountDown()
      })
    })
    loadSectionTranslations('cms')
  },
  computed: {
    isMobile() {
      return this.$mq == 'tablet' || this.$mq == 'tabletLandscape'
    },
  },
  methods: {
    closeController() {
      this.active = false
      if (this.isMobile) document.body.style.removeProperty('overflow')
    },

    setCountDown() {
      let content = this.$slots.default.filter(c => !c.text)
      let endsInTranslation = this.$t('promobar_ends_in')
      let now = new Date()
      now = Date.parse(now).toString()

      content.map(slot => {
        const startDate = slot?.data?.attrs['data-start']
        if (slot?.data?.attrs['data-countdown'] != 'false' && startDate <= now) {
          const dataHighlighted =
            slot?.data?.attrs['data-highlighted'] == 'true'
              ? 'header-top-controller--content__countdown-highlighted'
              : ''

          setInterval(
            function() {
              this.children[2].elm.innerHTML = `  ${endsInTranslation}: ${setCountdown(
                `${slot?.data?.attrs['data-end']}`,
                'days'
              )}`
            }.bind(slot),
            100
          )
          slot?.data?.attrs['data-countdown'] != 'false'
          slot?.children[2]?.elm?.classList.add(dataHighlighted)
        }
      })
    },
    onAfterEnter() {
      this.$refs.bannerContent.focus()
    },
  },
}
